import {
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  signal,
  ViewChild,
  WritableSignal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsProjectIconComponent} from "../icons/bs-project-icon.component";
import {BsCadIconComponent} from "../icons/bs-cad-icon.component";
import {BsDrawingIconComponent} from "../icons/bs-drawing-icon.component";
import {BsBuildKitIconComponent} from "../icons/bs-build-kit-icon.component";
import {Tooltip} from "primeng/tooltip";
import {BsSideNavigationMenuComponent} from "../ui/bs-side-navigation-menu/bs-side-navigation-menu.component";
import {BsSwLogoComponent} from "../icons/bs-sw-logo.component";
import {BsCategoriesIconComponent} from "../icons/bs-categories-icon.component";
import {selectGlobalSearchResults, selectGlobalSearchStatus} from "../state/global-search/global-search.selectors";
import {select, Store} from "@ngrx/store";
import {debounceTime} from "rxjs";
import {executeGlobalSearch} from "../state/global-search/global-search.action";
import {GroupByPipe} from "../pipes/group-by.pipe";
import {Select} from "primeng/select";
import {StyleClass} from "primeng/styleclass";
import {Router, RouterLink} from "@angular/router";
import {GlobalSearchResultItem, SearchMenuItem} from "../models/global-search.model";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";
import {InputText} from "primeng/inputtext";
import {Divider} from "primeng/divider";
import {toSignal} from "@angular/core/rxjs-interop";
import {GlobalSearchHistoryService} from "../services/global-search-history.service";
 
 
 
@Component({
  selector: 'bs-global-search-bar',
  templateUrl: './bs-global-search-bar.component.html',
  styleUrls: ['./bs-global-search-bar.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, Tooltip, BsSideNavigationMenuComponent, BsSwLogoComponent, ReactiveFormsModule, BsCadIconComponent, GroupByPipe, Select, BsBuildKitIconComponent, BsProjectIconComponent, StyleClass, RouterLink, IconField, InputIcon, InputText, Divider, BsDrawingIconComponent]
})
export class BsGlobalSearchBarComponent implements OnInit {
  store = inject(Store);
  router = inject(Router);
  globalSearchHistoryService = inject(GlobalSearchHistoryService);
 
  @ViewChild('searchBar') searchBar!: ElementRef;
  @ViewChild('searchDialog') searchDialog!: ElementRef;
 
  isExpanded = false;
 
  globalSearchResult = this.store.selectSignal(selectGlobalSearchResults);
  globalSearchStatus = this.store.selectSignal(selectGlobalSearchStatus);
  globalSearchHistory = toSignal(this.globalSearchHistoryService.globalSearchHistory$);
 
  searchMenuItems: WritableSignal<any> = signal([
    {
      label: 'All results',
      searchMenuItem: SearchMenuItem.All,
      routerLink: 'projects',
      icon: BsCategoriesIconComponent
    },
    {
      label: 'Projects',
      searchMenuItem: SearchMenuItem.Projects,
      routerLink: 'projects',
      icon: BsProjectIconComponent
    },
    {
      label: 'CAD Data',
      searchMenuItem: SearchMenuItem.CadData,
      routerLink: 'cad-data',
      icon: BsCadIconComponent
    },
    {
      label: 'Drawing',
      searchMenuItem: SearchMenuItem.Drawings,
      routerLink: 'drawings',
      icon: BsDrawingIconComponent
    },
    {
      label: 'Build Kits',
      searchMenuItem: SearchMenuItem.BuildKits,
      routerLink: 'build-kit',
      icon: BsBuildKitIconComponent
    },
    // {
    //   label: 'Reports',
    //   searchMenuItem: SearchMenuItem.Reports,
    //   routerLink: 'reports',
    //   icon: BsReportIconComponent
    // },
    // {
    //   label: 'Library',
    //   searchMenuItem: SearchMenuItem.Library,
    //   routerLink: 'global-configurations',
    //   icon: BsLibraryIconComponent,
    // },
  ]);
 
  selectedMenuItem = signal(this.searchMenuItems()[0]);
 
  filteredGlobalSearchResults = computed(() => {
    console.log(this.selectedMenuItem().searchMenuItem === SearchMenuItem.All);
    if (this.selectedMenuItem().searchMenuItem === SearchMenuItem.All){
      return this.globalSearchResult();
    }
    return this.globalSearchResult()?.filter((result) => {
      return this.selectedMenuItem().searchMenuItem === result.searchType
    });
  })
 
  filteredGlobalSearchHistory = computed(() => {
    console.log(this.selectedMenuItem().searchMenuItem === SearchMenuItem.All);
    if (this.selectedMenuItem().searchMenuItem === SearchMenuItem.All){
      return this.globalSearchHistory();
    }
    return this.globalSearchHistory()?.filter((result) => {
      return this.selectedMenuItem().searchMenuItem === result.searchType
    });
  })
 
 
  constructor() { }
 
  searchInputForm = new FormControl<string | null>({
    value: null, disabled: false
  });
 
  ngOnInit(){
    this.searchInputForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(searchTerm => {
        if (searchTerm) {
          this.store.dispatch(executeGlobalSearch({ searchTerm }))
        }
      });
  }
 
  onFocus(): void {
    this.isExpanded = true;
  }
 
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const searchBarElement = this.searchBar.nativeElement;
    const searchDialogElement = this.searchDialog.nativeElement;
 
    if (!searchBarElement.contains(event.target) && !searchDialogElement.contains(event.target)) {
      this.isExpanded = false;
    }
  }
 
  itemClicked(item: GlobalSearchResultItem){
    this.isExpanded = false;
    this.globalSearchHistoryService.addGlobalSearch(item);
    if(item){
      let route = '';
      switch(item.searchType) {
        case 'Projects':
          this.router.navigate(['projects'], { queryParams: { globalSearch: item.id} });
          break;
        case 'CadModels':
          this.router.navigate([`cad-data/${item.id}`], { queryParams: { revision: item.idTwo} });
          break;
        case 'Drawings':
          if(item.idTwo && item.idThree){
            this.router.navigate([`cad-data/${item.idTwo}`], { queryParams: { revision: item.idThree, drawing: item.id} });
          } else {
            this.router.navigate([`drawings/${item.id}`]);
          }
          break;
        case 'BuildKits':
          this.router.navigate([`build-kit/${item.id}/cad-data`]);
          break;
        case 'Reports':
          route = ''
          break;
        case 'Library':
          route = ''
          break;
      }
 
    }
  }
 
  protected readonly select = select;
}
 